export default function TableFilter({ setting, style }) {
    if (setting.ifFiltered) {
        return <div style={style}>
            {setting.get}

        </div>
    }
}
